import { JSX } from "solid-js";

/**
 * Standard page header: title on the left, optional trailing
 * actions (buttons, filters) on the right.
 */
export default function PageHeader(props: {
  title: string;
  subtitle?: string;
  actions?: JSX.Element;
}) {
  return (
    <div class="flex items-start justify-between mb-4">
      <div>
        <h1 class="text-xl font-semibold tracking-tight">{props.title}</h1>
        {props.subtitle && (
          <p class="text-sm text-slate-500 mt-0.5">{props.subtitle}</p>
        )}
      </div>
      {props.actions && <div class="flex gap-2">{props.actions}</div>}
    </div>
  );
}
